import __var_0__ from '@stdlib/math/base/special/pow';
import __var_1__ from '@stdlib/math/base/special/ln';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var pow = __var_0__;
var ln = __var_1__;


// MAIN //

/**
* Returns a pseudorandom number drawn from a Weibull distribution.
*
* @private
* @param {PRNG} rand - PRNG for generating uniformly distributed numbers
* @param {PositiveNumber} k - scale parameter
* @param {PositiveNumber} lambda - shape parameter
* @returns {NonNegativeNumber} pseudorandom number
*/
function weibull( rand, k, lambda ) {
	return lambda * pow( -ln( 1.0-rand() ), 1.0/k );
}


// EXPORTS //
export default weibull;
